<template>
  <div class="WebAnalytics padding">
    <div class="d-xl-flex">
      <FormInput
        v-model="$v.merchantAccountId.$model"
        class="form-element"

        :ske="true"
        id="merchantAccountId"
        label="Google Merchant account-ID"
        :vuelidate="$v"
        fieldName="merchantAccountId"
      />
      <FormInput
        v-model="$v.adsId.$model"
        class="form-element middle"

        :ske="true"
        :vuelidate="$v"
        id="adsId"
        label="Google Ads account-ID"
        :focus="true"
        fieldName="adsId"
      />
      <FormInput
        v-model="$v.magentoStoreId.$model"
        class="form-element middle"

        :ske="true"
        :disabled="true"
        id="magentoStoreId"
        label="Winkel-ID"
        :vuelidate="$v"
        fieldName="magentoStoreId"
      />
    </div>
    <div class="d-xl-flex">
      <FormInput
        v-model="$v.defaultBudgetPerProduct.$model"
        class="form-element"

        :ske="true"
        :default="0.25"
        id="defaultBudgetPerProduct"
        label="Standaardbudget per product"
        :vuelidate="$v"
        fieldName="defaultBudgetPerProduct"
      />
      <FormInput
        v-model="$v.maxSiteBudget.$model"
        class="form-element middle"

        :ske="true"
        :vuelidate="$v"
        :default="10"
        id="maxSiteBudget"
        label="Maximaal sitebudget"
        :focus="true"
        fieldName="maxSiteBudget"
      />
    </div>
    <div class="d-xl-flex">
      <FormTextarea
        v-model="$v.googleSiteVerificationMeta.$model"
        class="form-element"

        :ske="true"
        id="googleSiteVerificationMeta"
        label="Google Site Verificatie Meta"
        :vuelidate="$v"
        fieldName="googleSiteVerificationMeta"
      />
      <FormTextarea
        v-model="$v.googleFeedLink.$model"
        class="form-element"

        :ske="true"
        id="googleFeedLink"
        label="google feedlink"
        :vuelidate="$v"
        fieldName="googleFeedLink"
      />
    </div>
    <div class="d-xl-flex">
      <FormInput
        v-model="$v.emailAddresses.$model"
        class="form-element"

        :ske="true"
        :vuelidate="$v"
        id="emailAddresses"
        label="E-mail toegang Google Adwords (Gescheiden door komma's)"
        :focus="true"
        fieldName="emailAddresses"
      />
      <span class="form-element"></span>
    </div>

    <CardTabs
        :tabs="tabs"
        v-model="tabState"
        class="card-tabs mt-4"
      />

    <GenericCrud v-if="tabState === 'seo-headlines'"
      v-model="seo_headlines"
      inputPlaceholder="SEO-kop..."
      @input="val => $emit('update:seo_headlines', val)"
      new-item-message="Nieuwe kop toevoegen."
    />
    <GenericCrud v-else-if="tabState === 'seo-descriptions'"
      v-model="seo_descriptions"
      inputPlaceholder="SEO-beschrijving..."
      @input="val => $emit('update:seo_descriptions', val)"
      new-item-message="SEO-beschrijving toevoegen."
    />
    <GenericCrud v-else-if="tabState === 'seo-keywords'"
      v-model="keywords"
      inputPlaceholder="SEO-zoekwoord..."
      @input="val => $emit('update:keywords', val)"
      new-item-message="Nieuw zoekwoord toevoegen."
    />

    <!-- <div class="d-xl-flex">
      <FormInput v-model="$v.google_analytics_campaign_id.$model" class="form-element"
        :ske="true"
        id="google_analytics_campaign_id"
        label="Google Analytics-campagne-ID"
        :vuelidate="$v"

        fieldName="google_analytics_campaign_id"
      />
      <FormInput v-model="$v.google_analytics_advertisement_budget_day.$model" class="form-element"
        :ske="true"
        id="google_adwords_advertisement_budget_day"
        label="Google Analytics-advertentiebudget per dag"
        :vuelidate="$v"

        fieldName="google_analytics_advertisement_budget_day"
      />
    </div> -->
  </div>
</template>

<script>

import setupForm from "../../mixins/setupForm"

import { decimal, integer } from "vuelidate/lib/validators"

import GenericCrud from "../../layout/GenericCrud/GenericCrud.vue"
import CardTabs from "../../layout/CardTabs.vue"
import FormInput from "../Inputs/FormInput.vue"
import FormTextarea from "../Inputs/FormTextarea.vue"

const fields = [
  "google_analytics_account_number", "google_adwords_conversion_id", "seo_headlines", "seo_descriptions", "keywords",
  "merchantAccountId", "adsId", "magentoStoreId", "defaultBudgetPerProduct", "maxSiteBudget", "googleSiteVerificationMeta",
  "googleFeedLink", "emailAddresses"
]

// "google_analytics_campaign_id", "google_analytics_advertisement_budget_day"

export default setupForm(fields, {
  components: {
    FormInput,
    CardTabs,
    GenericCrud,
    FormTextarea
  },
  data() {
    return {
      tabState: 'seo-headlines',
      seo_headlines: [],
      seo_descriptions: [],
      keywords: [],
    }
  },
  validations: {
    ...fields.reduce((obj, key) => ({
      ...obj,
      [key]: {
      },
    }), {}),

    defaultBudgetPerProduct: { decimal },
    maxSiteBudget: { decimal },
  },
  computed: {
    tabs() {
      return [
        {
          name: "SEO Krantenkoppen",
          id: "seo-headlines",
        },
        {
          name: "SEO Beschrijvingen",
          id: "seo-descriptions",
        },
        {
          name: "SEO-zoekwoorden",
          id: "seo-keywords",
        },
      ]
    },
  }
})

</script>

<style scoped>

.WebAnalytics {
  width: 100%;
}

</style>

<style scoped src="@/assets/css/form.css"></style>
